import axios from "axios";
import strings from "../../components/strings";

const BASE_URL = process.env.REACT_APP_BASE_URL;;

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
});  